import React from "react";
import HelpChatWindow from "../../components/HelpChatWindow/HelpChatWindow";

const Help: React.FC = () => {
    return (
        <>
            <HelpChatWindow />
        </>
    )
}

export default Help